import React from "react";
import "./job.css";
import { ReactComponent as ArrowSVG } from "../../../images/apply_job_arrow.svg";

const Job = ({ role, department, locations }) => {
  return (
    <div>
      <div className="job row">
        <div className="role col col-12 col-xl-6">{role}</div>
        <div className="job-body col col-12 col-xl-6">
          <div className="info">
            <div className="department">{department}</div>
            <div className="dot">•</div>
            <div className="locations">
              {locations.map((location, index) => (
                <span key={index}>
                  {index === 0 ? undefined : "/ "}
                  {location}
                </span>
              ))}
            </div>
          </div>
          <div className="visit-jd">
            <span className="text">Apply now</span>
            <ArrowSVG className="arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Job;
